import { useEffect } from "react";
import { Navbar } from "../components/landing/Navbar";
import { SmartHero } from "../components/smart/SmartHero";
import { SmartDespre } from "../components/smart/SmartDespre";
import { SmartHowItWorks } from "../components/smart/SmartHowItWorks";
import { SmartAvantaje } from "../components/smart/SmartAvantaje";
import { SmartLegitimare } from "../components/smart/SmartLegitimare";
import { SmartISIC } from "../components/smart/SmartISIC";
import { SmartHistory } from "../components/smart/SmartHistory";
import { SmartBenefitsNational, SmartBenefitsGlobal } from "../components/smart/SmartCarousels";

export default function SmartCampus() {
  useEffect(() => {
    const prev = document.title;
    document.title = "ISIC Smart Campus";
    return () => {
      document.title = prev;
    };
  }, []);

  return (
    <div className="App font-sans text-ink bg-white antialiased">
      <Navbar />
      <main>
        <SmartHero />
        <SmartDespre />
        <SmartHowItWorks />
        <SmartAvantaje />
        <SmartLegitimare />
        <SmartISIC />
        <SmartHistory />
        <SmartBenefitsNational />
        <SmartBenefitsGlobal />
      </main>
    </div>
  );
}
